import { h, Component } from 'preact';
import {Form, Button, Container, Col, Row} from 'components/elements'
import WidgetComponent from 'components/WidgetComponent'
import {connect} from 'react-redux'
import style from './index.less'
import {AccountActions, PageActions, PatientActions} from 'actions'
import store from 'reducers'
import {FACheckCircle, FADotCircle, FASpinner} from 'components/elements/FontAwesome'

@Form
@connect((state)=> state)
export default class ResetPrompt extends WidgetComponent {
    constructor(props, context){
        super(props, context)
        this.state = {
            passwordError: false,
            resetError: false,
            resetSent: false,
            value: ''
        }
        this.handleResetPassword = this.handleResetPassword.bind(this)
        this.handlePassword = this.handlePassword.bind(this)
        this.handlePasswordConfirmation = this.handlePasswordConfirmation.bind(this)
    }

    handleResetPassword(values){
        if(values.password && values.confirmPassword && values.password == values.confirmPassword){
            this.setState({
                submittingPassword: true,
                passwordError: false,
                passwordErrorMessage: ''
            })
            AccountActions.update({password: values.password, passwordConfirmation: values.confirmPassword}).then((response)=>{
                this.setState({
                    submittingPassword: false
                })
                PatientActions.fetch({organizationID: this.props.organization.id})
                PageActions.navToFilters()
            }).catch((e)=>{
                this.setState({
                    submittingPassword: true
                })
                e = (e.response.data || {}).errors || ''
                
                let errorMessage = []
                if(e.includes("min")){
                    errorMessage.push("Must be at least 8 characters")
                }
                if(e.includes("uppercase")){
                    errorMessage.push("Must have at least 1 upper case character")
                }
                if(e.includes("digits")){
                    errorMessage.push("Must have at least 1 digit")
                }
                
                this.setState({
                    submittingPassword: false,
                    passwordError: true,
                    passwordErrorMessage: `Invalid Password: ${errorMessage.join(", ")}`
                })
            })
        } else {
            this.setState({
                submittingPassword: false,
                passwordError: true,
                passwordErrorMessage: `Passwords do not match`
            })
        }
    }

    handlePassword(e){
        const value = e.target.value
        this.setState({
          passwordValue: value,
          passwordConfirmationMatches: value == this.state.passwordConfirmationValue,
          hasNumber: value.match(/(?=.*\d)/),
          hasLowerCase: value.match(/(?=.*[a-z])/),
          hasUpperCase: value.match(/(?=.*[A-Z])/),
          hasEightCharacters:  value.match(/(?=.{8,8})/)
        })
      }

      handlePasswordConfirmation(e){
        const value = e.target.value
        this.setState({
          passwordConfirmationValue: value,
          passwordConfirmationMatches: value == this.state.passwordValue
        })
      }

    render(){
        const {InputDark, Form} = this.props
        return (
            <Form class={style.login} onSubmit={this.handleResetPassword}>
                <Row class={this.props.class}>
                    <Col span={{sm:'hidden', md:5}}></Col>
                    <Col span={{sm:24, md:14}}>
                        <Container>
                            <Row>
                                <Col span={{md:1}}></Col>
                                <Col span={{sm: 24, md:22}} class={style.noPadding}> 
                                    <div>
                                        <strong>
                                            Enter Your New Password
                                        </strong>
                                        <br />
                                        <br />
                                        <InputDark 
                                            name='password' 
                                            id='password' 
                                            required={true} 
                                            question='Password' 
                                            type='password' 
                                            onChange={this.handlePassword}
                                        />
                                        <br />
                                        <InputDark 
                                            name='confirmPassword'
                                            id='confirmationPassword'
                                            required={true}
                                            question='Confirm Password'
                                            type='password'
                                            onChange={this.handlePasswordConfirmation}
                                        />
                                        <br />
                                        <div class={style.errorSpacing}>
                                            {this.state.passwordError && 
                                                <div class={style.errorMessage}>{this.state.passwordErrorMessage}</div>
                                            }
                                        </div>
                                        <div className='text-left'>
                                            <div>
                                                {this.state.hasNumber ?
                                                    <FACheckCircle class={style.checkedColor} /> :
                                                    <FADotCircle class={style.openColor} />
                                                } Has at least 1 number
                                            </div>
                                            <div>
                                                {this.state.hasUpperCase ?
                                                    <FACheckCircle class={style.checkedColor} /> :
                                                    <FADotCircle class={style.openColor} />
                                                } Has at least 1 uppercase letter
                                            </div>
                                            <div>
                                                {this.state.hasLowerCase ?
                                                    <FACheckCircle class={style.checkedColor} /> :
                                                    <FADotCircle class={style.openColor} />
                                                } Has at least 1 lowercase letter
                                            </div>
                                            <div>
                                                {this.state.hasEightCharacters ?
                                                    <FACheckCircle class={style.checkedColor} /> :
                                                    <FADotCircle class={style.openColor} />
                                                } Has at least 8 characters
                                            </div>
                                            <div>
                                                {this.state.passwordConfirmationMatches ?
                                                    <FACheckCircle class={style.checkedColor} /> :
                                                    <FADotCircle class={style.openColor} />
                                                } Password Confirmation Matches
                                            </div>
                                        </div>
                                        <Row>
                                            <Col span={{sm:6, md:8}}></Col>
                                            <Col span={{sm:12, md:8}}>
                                                <div class={style.searchButton}>
                                                    {this.state.submittingPassword ?
                                                        <FASpinner class={style.buttonSpinner} />
                                                    :
                                                        <Button>Submit</Button>
                                                    }
                                                </div>
                                            </Col>
                                        </Row>
                                    </div>
                                </Col> 
                            </Row>
                        </Container>
                    </Col>
                </Row>
            </Form>    
        )
    }
}


// WEBPACK FOOTER //
// ./components/partials/PasswordReset/index.js